/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/require-default-props */
import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Slide,
} from '@material-ui/core';
import { CloseRounded, ListRounded } from '@material-ui/icons';
import useOnClickOutside from '@src/hooks/useOnClickOutside';
import { parseMessage } from '@src/locales/intl';
import { chatViewerActions } from '@src/reducers/chatViewer';
import {
  getDepartmentList,
  showDepartmentList,
} from '@src/selectors/chatViewer';
import { DepartmentList, TimelineEvent } from '@src/types';
import { urlAgentConsole, urlAuditV2 } from '@src/utils/adminRoutes';
import useWindowSize from '@src/utils/useWindowSize';
import { FC, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

type ListTypeMessageProps = {
  message: TimelineEvent;
};

type DepartmentsButtonProps = {
  title?: string | null;
  departmentList?: DepartmentList[];
};

type DepartmentsDialogProps = {
  customClasses?: string;
};

const lblBotMsg = parseMessage('BotMessage');

const ListTypeMessage: FC<ListTypeMessageProps> = ({ message }) => {
  const { footerText, bodyText, headerText } = message;

  return (
    <Box className="ltm">
      <span className="ltm_title">{`🤖 ${lblBotMsg}`}</span>
      {headerText && <span className="ltm_header">{headerText}</span>}
      {bodyText && <span className="ltm_header">{bodyText}</span>}
      {footerText && <span className="ltm_footer">{footerText}</span>}
    </Box>
  );
};

export const DepartmentsButton: FC<DepartmentsButtonProps> = ({
  title,
  departmentList,
}) => {
  const openList = useSelector(showDepartmentList);
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    dispatch(
      chatViewerActions.onShowDepartmentList({ list: departmentList, title })
    );
  };

  return title ? (
    <Box className="departments-button">
      <Divider style={{ width: '100%' }} />
      <Button
        fullWidth
        style={{ color: '#478ecc' }}
        startIcon={<ListRounded />}
        onClick={handleClickOpen}
        disabled={openList}
      >
        {title}
      </Button>
    </Box>
  ) : null;
};

export const DepartmentSlide: FC<DepartmentsDialogProps> = ({
  customClasses,
}) => {
  const { pathname } = useLocation();
  const height = useWindowSize()[1];
  const open = useSelector(showDepartmentList);
  const departaments = useSelector(getDepartmentList);
  const dispatch = useDispatch();
  const chatContainer = document.querySelector('#chat-container');
  const [listHeight, setListHeight] = useState(250);
  const viewerClass = pathname.startsWith('/viewer/') ? 'ds_viewer' : '';
  const isAuditModule = pathname === urlAuditV2;
  const isChatModule = pathname === urlAgentConsole;
  const paperRef = useRef(null);

  useLayoutEffect(() => {
    if (isChatModule && open) {
      setListHeight((chatContainer?.clientHeight || 300) - 50);
    }
  }, [height, open]);

  const onClose = () => {
    dispatch(chatViewerActions.onShowDepartmentList());
  };

  const handleClickOutsideFn = () => {
    onClose();
  };

  useOnClickOutside(paperRef, handleClickOutsideFn);

  return (
    <Box position={`${isAuditModule ? 'initial' : 'relative'}`}>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Paper
          style={{ maxHeight: `${isChatModule ? `${listHeight}px` : '90%'}` }}
          className={`departments-slide ${customClasses} ${viewerClass}`}
          ref={paperRef}
        >
          <Box className="ds_header">
            <hr className="ds_line" />
            <Box className="ds_title">
              <IconButton size="small" onClick={onClose}>
                <CloseRounded />
              </IconButton>
              <span>{departaments?.title}</span>
            </Box>
          </Box>
          <Box className="ds_content">
            {departaments?.list?.map(item => (
              <Box className="ds_dep" key={item.id}>
                <Box className="ds_dep__header">{item.title}</Box>
                {item.description && (
                  <Box className="ds_dep__footer">{item.description}</Box>
                )}
              </Box>
            ))}
          </Box>
        </Paper>
      </Slide>
    </Box>
  );
};

export default ListTypeMessage;
